import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import type { DesignVersion, Design } from '../types/editor.types';
import { generateId } from '../utils';

const MAX_VERSIONS = 50;

interface VersionsState {
  versions: DesignVersion[];
  addVersion: (designId: string, snapshot: Design, label?: string) => void;
  getVersions: (designId: string) => DesignVersion[];
  clearVersions: (designId: string) => void;
}

export const useVersionsStore = create<VersionsState>()(
  persist(
    immer((set, get) => ({
      versions: [],

      addVersion: (designId, snapshot, label) =>
        set((s) => {
          s.versions.unshift({
            id: generateId(),
            designId,
            snapshot,
            label: label ?? `Version ${new Date().toLocaleTimeString()}`,
            createdAt: new Date().toISOString(),
          });
          const projectVersions = s.versions.filter((v: DesignVersion) => v.designId === designId);
          if (projectVersions.length > MAX_VERSIONS) {
            const oldest = projectVersions[projectVersions.length - 1];
            s.versions = s.versions.filter((v: DesignVersion) => v.id !== oldest.id);
          }
        }),

      getVersions: (designId) =>
        get().versions.filter((v: DesignVersion) => v.designId === designId),

      clearVersions: (designId) =>
        set((s) => { s.versions = s.versions.filter((v: DesignVersion) => v.designId !== designId); }),
    })),
    { name: 'design-studio-versions' }
  )
);
